import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { Core } from "@faire/design-tokens";
import { useStrictLocalization } from "@faire/web--source/common/localization";
import { Spacer } from "@faire/web--source/slate/spacing";
import { Typography } from "@faire/web--source/slate/Typography";
import { useViewport } from "@faire/web--source/ui/hooks/useViewport";
import React from "react";
import { BrandRating } from "@faire/retailer/views/suppliers/__internal__/LazySuppliersPage/__internal__/SuppliersPage/__internal__/LoggedOutSuppliersPage/__internal__/Components/LoggedOutSuppliersPageBrandReviewTile/__internal__/BrandRating";
export var BrandReview = function(param) {
    var _param_item = param.item, comment = _param_item.comment, location = _param_item.location, retailer_name = _param_item.retailer_name, brand_review_summary = _param_item.brand_review_summary;
    var strictLocalize = useStrictLocalization().strictLocalize;
    var isMobile = useViewport().isMobile;
    if (!brand_review_summary) {
        return null;
    }
    return /*#__PURE__*/ _jsxs(_Fragment, {
        children: [
            /*#__PURE__*/ _jsx(Spacer, {
                height: "2x"
            }),
            /*#__PURE__*/ _jsx(BrandRating, {
                brandReviewSummary: brand_review_summary
            }),
            comment ? /*#__PURE__*/ _jsxs(_Fragment, {
                children: [
                    /*#__PURE__*/ _jsx(Spacer, {
                        height: "1x"
                    }),
                    /*#__PURE__*/ _jsx(Typography, {
                        maxLines: isMobile ? 5 : 4,
                        children: wrapStringInQuotes(comment, strictLocalize)
                    }),
                    /*#__PURE__*/ _jsx(Spacer, {
                        height: "1x"
                    }),
                    /*#__PURE__*/ _jsx(Typography, {
                        color: Core.text.subdued,
                        children: "".concat(retailer_name, " (").concat(location, ")")
                    })
                ]
            }) : null
        ]
    });
};
var wrapStringInQuotes = function(message, strictLocalize) {
    return strictLocalize({
        id: "RpKsQx",
        defaultMessage: [
            {
                type: 0,
                value: "\u201C"
            },
            {
                type: 1,
                value: "quoteAsFullyTranslatedSentence"
            },
            {
                type: 0,
                value: "\u201D"
            }
        ]
    }, {
        quoteAsFullyTranslatedSentence: message
    });
};
